import SubmitContext from 'context/submit/submitContext'
import React, { useContext } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAsterisk } from '@fortawesome/free-solid-svg-icons'
import { faCloudArrowDown } from '@fortawesome/free-solid-svg-icons'

export function useFormUtils() {
  const submitContext = useContext(SubmitContext)

  const { current, setCurrent } = submitContext

  const setSelect = ({ value, subCategory }, fieldName) => {
    if (subCategory) {
      setCurrent({
        ...current,
        [fieldName]: value,
        subCategory: subCategory,
      })
    } else {
      setCurrent({ ...current, [fieldName]: value })
    }
  }

  const onChange = ({ target: { name, value } }) => {
    setCurrent({ ...current, [name]: value })
  }

  const setSwitch = (checked, event, id, trueSubCategory, falseSubCategory) => {
    if (falseSubCategory && trueSubCategory) {
      setCurrent({
        ...current,
        [id]: checked,
        subCategory: checked ? trueSubCategory : falseSubCategory,
      })
    } else {
      setCurrent({ ...current, [id]: checked })
    }
  }

  const setSelectReviewer = (item, { value, subCategory }, { name }) => {
    item[name] = value
    if (subCategory) item['fkSubCategory'] = subCategory
  }

  const onChangeReviewer = (item, { target: { name, value } }) => {
    item[name] = value
  }

  const setSwitchReviewer = (
    item,
    checked,
    event,
    id,
    trueSubCategory,
    falseSubCategory
  ) => {
    item[id] = checked
    if (falseSubCategory && trueSubCategory) {
      checked
        ? (item['fkSubCategory'] = trueSubCategory)
        : (item['fkSubCategory'] = falseSubCategory)
    }
  }

  const checkImages = images => {
    if (!images) return false
    return (
      images.filter(
        image => image.ImageName && image.ImageType && image.ProdImg
      ).length > 0
    )
  }

  const asterisk = (
    <FontAwesomeIcon
      icon={faAsterisk}
      size="xs"
      color="red"
      transform="up-5 shrink-1"
    />
  )

  const download = (
    <FontAwesomeIcon icon={faCloudArrowDown} transform="left-5" />
  )

  return {
    setSelect: (selected, fieldName) => setSelect(selected, fieldName),
    onChange: event => onChange(event),
    setSwitch: (checked, event, id, trueSubCategory, falseSubCategory) =>
      setSwitch(checked, event, id, trueSubCategory, falseSubCategory),
    setSelectReviewer: (item, selected, value) =>
      setSelectReviewer(item, selected, value),
    onChangeReviewer: (item, event) => onChangeReviewer(item, event),
    setSwitchReviewer: (
      item,
      checked,
      event,
      id,
      trueSubCategory,
      falseSubCategory
    ) =>
      setSwitchReviewer(
        item,
        checked,
        event,
        id,
        trueSubCategory,
        falseSubCategory
      ),
    checkImages: images => checkImages(images),
    asterisk,
    download,
  }
}
